








import Vue from 'vue'
import Observer from './Observer/Observer.vue'
import { isImageValid } from './utils/validators'
export default Vue.extend({
	name: 'ProgressiveLoader' as string,
	props: {
		image: {
			type: String,
			validator: (propValue) => {
				return isImageValid(propValue)
			}
		},
		placeholder: {
			type: String,
			validator: (propValue) => {
				return isImageValid(propValue)
			}
		},
		alt: {
			type: String,
			default: ''
		},
		width: {
			type: Number
		},
		height: {
			type: Number
		},
		observer: {
			type: Boolean,
			default: true
		},
		triggerLoad: {
			type: Boolean,
			default: false
		}
	},
	components: {
		"Observer": Observer
	},
	data: () => ({
		loaded: false,
		aspectRatio: 0
	}),
	beforeMount(): void {
		if (!this.width || !this.height) {
			const img = new Image()
			img.src = this.placeholder

			this.setAspectRatio(img.width, img.height)
		} else {
			this.setAspectRatio(this.width, this.height)
		}

		if (!this.observer) {
			this.$watch('triggerLoad', function(newVal: boolean) {
				if (newVal) {
					this.loadImage()
				}
			})
		}
	},
	methods: {
		loadImage(): void {
			(this.$refs.largeImage as HTMLImageElement).src = this.image
			const img: HTMLImageElement = new Image()

			img.src = this.image
			img.onload = () => {
				this.loaded = true
				this.setAspectRatio(img.width, img.height)
			}
		},
		setAspectRatio(width: number, height: number): void {
			this.aspectRatio = (height / width) * 100
		}
	}
})
